import { Link } from "react-router-dom";
import { Carousel } from "@/components/Carousel";
import { VideoCard } from "@/components/VideoCard";

const titleCls = "text-[20px] md:text-[24px] lg:text-[28px] 4xl:text-[34px] font-bold leading-tight mb-4 md:mb-6 lg:mb-7";

export const VideoRow = ({ title, videos, to, testId }) => (
  <section className="mt-8 md:mt-10 lg:mt-12 df-fade-up" data-testid={testId}>
    {to ? (
      <Link to={to} className={`inline-block hover:underline ${titleCls}`} data-testid="video-row-title">
        {title}
      </Link>
    ) : (
      <h2 className={titleCls} data-testid="video-row-title">
        {title}
      </h2>
    )}
    <Carousel items={videos} render={(v) => <VideoCard video={v} />} perView={{ base: 1.15, sm: 2, lg: 3, "3xl": 4 }} gap={20} />
  </section>
);

export const VideoGrid = ({ videos }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 gap-5" data-testid="video-grid">
    {videos.map((v) => (
      <VideoCard key={v.id} video={v} />
    ))}
  </div>
);
